const columnChartSnapshot = {
    id: 'cGFuZWw6NWQ4YzU1Yjg0MDRhZmE3MGFjMWRiM2Iw',
    partnerId: 349,
    clientId: 7101,
    name: 'Column Chart',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4YzU1Yjg0MDRhZmE3MGFjMWRiM2Fm',
        name: 'Scene 9',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'Column Chart',
                type: 'barChart',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {},
                    postVersion: 1,
                    zeroFill: true,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    labelSize: 33,
                    showMetricName: true,
                    metricNameSize: 15,
                    metricNameCase: 'lowercase',
                    showMetricValue: true,
                    metricValueSize: 50,
                    metricValueFormat: '1k',
                    showMetricChange: false,
                    metricPercentChangeSize: 17,
                    highlightPercentChange: false,
                    stacked100Percent: false,
                    stackedInline: false,
                    showTimeRemainder: true,
                    spacing: 6,
                    padding: 21,
                    thresholds: [],
                    thresholdsEnabled: false,
                    thresholdsLegend: false,
                    thresholdsStacked: false,
                    thresholdLineWidth: 0.5,
                    thresholdsPercent: false,
                    thresholdsAxis: true,
                    thresholdsDashed: false,
                    maxThresholds: 5,
                    labelTextFormat: 'clamp',
                    labelLineClamp: true,
                    labelLineClampValue: 1,
                    labelWrapText: false,
                    endianTime: 'MMM DD',
                    blacklist: [],
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                        baseline: {
                            spacing: 6,
                            padding: 21,
                            labelSize: 25,
                            metricValueSize: 50,
                            metricPercentChangeSize: 17,
                            metricNameSize: 15,
                        },
                        optionDefaults: {
                            labelEnable: true,
                            showMetricName: true,
                            showMetricValue: true,
                            showMetricChange: true,
                            showTimeRemainder: true,
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    labelEnable: false,
                                    showMetricName: false,
                                    showMetricValue: false,
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                            s: {
                                options: {
                                    showMetricName: false,
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                            m: {
                                options: {
                                    showMetricChange: false,
                                    showTimeRemainder: false,
                                },
                            },
                        },
                    },
                    orientation: 'horizontal',
                    showSentiment: false,
                    portrait: {
                        widgetOrientation: 'portrait',
                        limit: 3,
                        metricNameSize: 15,
                        labelSize: 20,
                    },
                },
                userAssetContentUrl: null,
                postRequests: null,
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '0',
                    right: null,
                    top: '0',
                    bottom: null,
                    width: '100%',
                    height: '100%',
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: [
                    {
                        includeTotal: null,
                        additional: {
                            TARGET_LANG_CODE: null,
                            Currency: null,
                            slaConfig: null,
                        },
                        reportingEngine: 'LISTENING',
                        report: 'SPRINKSIGHTS',
                        limit: 6,
                        sorts: [
                            {
                                heading: 'Mentions',
                                order: 'DESC',
                            },
                            {
                                heading: 'Country',
                                order: 'ASC',
                            },
                        ],
                        timePeriods: [
                            {
                                startTime: 1567321200000,
                                endTime: 1569913199999,
                                timeZone: 'America/Los_Angeles',
                                key: 'this_month',
                                duration: 86400000,
                                previousPeriod: false,
                                wholePeriods: false,
                                xValue: null,
                            },
                            {
                                startTime: null,
                                endTime: null,
                                timeZone: 'America/Los_Angeles',
                                key: null,
                                duration: 86400000,
                                previousPeriod: true,
                                wholePeriods: false,
                                xValue: null,
                            },
                        ],
                        groupBys: [
                            {
                                heading: 'Country',
                                dimensionName: 'COUNTRY',
                                groupType: 'FIELD',
                                resolveName: false,
                                details: null,
                            },
                        ],
                        filters: [
                            {
                                dimensionName: 'TOPIC_GROUP_IDS',
                                filterType: 'IN',
                                values: ['5a00b9e4e4b082264ab84227', '5cf57536e4b0dfcad24ff662'],
                                details: null,
                            },
                        ],
                        projections: [
                            {
                                heading: 'Mentions',
                                measurementName: 'MENTIONS_COUNT',
                                aggregateFunction: 'SUM',
                                details: {
                                    origReport: 'SPRINKSIGHTS',
                                    origOrder: 0,
                                },
                            },
                        ],
                    },
                ],
                analyticsResults: [
                    {
                        dataSets: [
                            {
                                dimensions: [
                                    {
                                        name: 'Country',
                                        type: 'STRING',
                                        dataType: null,
                                        convert: null,
                                    },
                                ],
                                metrics: [
                                    {
                                        name: 'Mentions',
                                        type: 'NUMBER',
                                        dataType: null,
                                        convert: null,
                                    },
                                ],
                                rows: [
                                    ['Brand 1', 182927],
                                    ['Brand 3', 174000],
                                    ['Brand 4', 82193],
                                    ['Brand 5', 70326],
                                    ['Brand 6', 59103],
                                ],
                                totals: [],
                            },
                        ],
                    },
                ],
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Column Chart',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_column_chart',
        theme: {
            colorFont: null,
            colorPrimary: '',
            colorSecondary: '#ff6060',
            colorBackground: '',
            colorNegative: '',
            colorPostive: '',
            ext: {
                padding: 40,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: '',
            fontFamilySecondary: '',
            fontSizePrimary: '',
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: {
                url: '',
                previewUrl: null,
                samId: null,
                name: null,
                description: null,
                backgroundRepeat: null,
                backgroundSize: null,
            },
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569478187979,
};
export default columnChartSnapshot;
